var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.portfolioStore.isNdf)?_c('ndf-positions',{attrs:{"mocked-enabled":_vm.mockedEnabled}}):_c('portfolio-positions',{attrs:{"mocked-enabled":_vm.mockedEnabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }